import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'leftTruncate'
})
export class LeftTruncatePipe implements PipeTransform {
  transform(value: string, maxLength: number = 14): string {
    if (!value) {
      return '';
    }
    if (value.length > maxLength) {
      return '…' + value.slice(-maxLength);
    }
    return value;
  }
}
